import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface PayloadInterface {
	user?: Record<string, any>;
	token?: string | null;
}

const initialState = {
	userInfo: {
		user: {},
		token: '',
	},
	previewsRole: '',
};

const authStore = (set: any) => ({
	...initialState,
	setUserInfo: (data: PayloadInterface) => set((state: any) => ({ ...state, userInfo: data })),
	setPreviewsRole: (role: string) => set((state: any) => ({ ...state, previewsRole: role })),
	updateUserInfo: (updates: Partial<Record<string, any>>) =>
		set((state: any) => ({
			...state,
			userInfo: {
				...state.userInfo,
				user: {
					...state.userInfo.user,
					...updates,
				},
			},
		})),
	resetState: () =>
		set((state: any) => ({
			...initialState,
			previewsRole: state.previewsRole,
		})),
});

const useAuthStore = create(
	devtools(
		persist(authStore, {
			name: 'auth',
		}),
	),
);

export const { setUserInfo, setPreviewsRole, resetState, updateUserInfo } = useAuthStore.getState();

export default useAuthStore;
